//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/DisplayableObject.js";
let d=[[],[[[],"GetWidth",{R_:{width:''}},0,0],[[],"GetParentTable",{R_:{tabnot:"Annotations.Annotation"}},0,0],[[],"GetNumberOfCells",{R_:{nmCells:''}},0,0],[["nth"],"GetIthCell",{R_:{ithCell:"Annotations.TableCell"}},1,0]],[]];
SPLM.Annotations.TableColumn = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TableColumn";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;